
/**
 * HOC to apply prop types to a component
 */

export default propTypes => Component => {
  Component.propTypes = propTypes
  return Component
}
